import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { selectAllCarImagesFolders, selectDealerFetchingResults, selectCustomerCarsByBusinessLine, selectDealerProfile } from 'src/app/common/store/state/app.state';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { Car } from 'src/app/public/car/models/car.model';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { TransactionStage, TransactionRole } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { FileData } from 'src/app/public/common/models/file-data.model';


@Component({
    selector: 'app-customer-buy-favorites',
    templateUrl: './customer-buy-favorites.component.html',
    styleUrl: './customer-buy-favorites.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerBuyFavoritesComponent {

  myBuyCars$: Observable<Car[]>;
  carImagesFolders$: Observable<Map<string, Array<FileData>>>;
  myProfile$: Observable<Dealer>;

  fetchingResults$: Observable<boolean>;

  businessLine: CarBusinessLine = CarBusinessLine.BUY;
  objectSource: ObjectSource = ObjectSource.BUY;
  transactionStages: TransactionStage[] = [TransactionStage.FAVORITE];
  transactionRole: TransactionRole = TransactionRole.CUSTOMER

   constructor(
  
      private store: Store, 
      private router: Router
      ) {

        this.fetchingResults$ = store.select(selectDealerFetchingResults);
  
        this.carImagesFolders$ = store.select(selectAllCarImagesFolders);
  
        this.myProfile$ = store.select(selectDealerProfile);
  
        this.myBuyCars$ = store.select(selectCustomerCarsByBusinessLine(this.businessLine))
  
      }
  
      ngOnInit() {
  
        //this.store.dispatch(DealerActions.fetchCustomerCarsSubmit({businessLine: this.businessLine, favoritesOnly: true}));
        this.store.dispatch(DealerActions.providerOffersFetchMySubmit({ transactionRole: this.transactionRole, businessLine: this.businessLine, transactionStages: this.transactionStages}));
  
    }

}
